import { render, staticRenderFns } from "./AbBothSidePlayerPerformance.vue?vue&type=template&id=367e7ad8&scoped=true"
import script from "./AbBothSidePlayerPerformance.vue?vue&type=script&lang=js"
export * from "./AbBothSidePlayerPerformance.vue?vue&type=script&lang=js"
import style0 from "./AbBothSidePlayerPerformance.vue?vue&type=style&index=0&id=367e7ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367e7ad8",
  null
  
)

export default component.exports